import { ButtonStyled } from './styled';

import { ButtonHTMLAttributes, JSX, useMemo } from 'react';

interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  title: string | JSX.Element;
  fullscreen?: boolean;
  buttonStyle?: 'primary' | 'secondary';
}

export const Button = ({ title, fullscreen, ...props }: ButtonProps) => {
  const getButtonStyles = useMemo(() => {
    const defaultStyles = { ...props.style };
    const width = fullscreen ? '100%' : props.style?.width;

    defaultStyles.width = width;

    switch (props.buttonStyle) {
      case 'primary':
        return {
          ...defaultStyles,
          backgroundColor: 'var(--color-primary-4)',
          color: '#000000',
        };
      case 'secondary':
        return undefined;
      default:
        return {
          backgroundColor: '#1F2630',
          color: '#fff',
          ...defaultStyles,
        };
    }
  }, [props.type, fullscreen]);

  return (
    <ButtonStyled {...props} style={getButtonStyles}>
      {title}
    </ButtonStyled>
  );
};
